import flatpickr from 'flatpickr';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';

document.addEventListener('DOMContentLoaded', () => {
  flatpickr('.js-date-picker', {
    locale: Japanese,
    minDate: 'today',
    altInput: true,
    altFormat: 'Y年m月d日',
    dateFormat: 'Y-m-d',
    disableMobile: 'true',
    allowInput: true
  });

  flatpickr('.js-date-picker-from-service-start', {
    locale: Japanese,
    minDate: '2018-07-01',
    maxDate: new Date(),
    altInput: true,
    altFormat: 'Y年m月d日',
    dateFormat: 'Y-m-d',
    disableMobile: 'true'
  });
});
